export function normalizeQuillListHtml(rawHtml: string): string {
  if (!rawHtml || typeof DOMParser === "undefined") return rawHtml;
  const parser = new DOMParser();
  const doc = parser.parseFromString(rawHtml, "text/html");
  const listItems = Array.from(
    doc.querySelectorAll<HTMLElement>("ol > li[data-list], ul > li[data-list]")
  );

  // Quill can emit bullet lists as <ol><li data-list="bullet">...</li></ol>.
  // In render mode (without Quill CSS), this appears numbered.
  listItems.forEach((li) => {
    const listType = li.getAttribute("data-list");
    if (!listType) return;

    const parent = li.parentElement;
    if (!parent) return;

    const targetTag =
      listType === "bullet" ? "ul" : listType === "ordered" ? "ol" : "";
    if (!targetTag) return;

    if (parent.tagName.toLowerCase() !== targetTag) {
      const replacement = doc.createElement(targetTag);
      replacement.className = parent.className;
      parent.parentNode?.insertBefore(replacement, parent);
      while (parent.firstChild) {
        replacement.appendChild(parent.firstChild);
      }
      parent.remove();
    }

    li.removeAttribute("data-list");
  });

  return doc.body.innerHTML;
}
